import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class CustomHtml extends BaseOption {
  static userInterfaceComponent = {
    label: "Custom HTML",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "textarea",
      placeholder: "Enter HTML here",
    },
  };

  static defaultValue = "";
}
